
  module.exports =
  {

    productsUsed:
    {

      _init: function ()
      {

        APPLICATION._APPLICATION.processLinks('#products-used', 'ProductsUsed', 'productsUsed')

      }

    },

    record:
    {

      _init: function ()
      {
  
        $('#modal-company_id').not('.js-ignore').change(function ()
        {
  
          var company_id = $(this).val()
  
          var development = $('#modal-coins_development_id')
  
          if ('' === company_id)
          {
            development.next('.dropdown-menu').html('')
          }
  
          else
          {
            APPLICATION._APPLICATION.loadDropdown(development, APPLICATION._PATH_PREFIX + 'development/coins-dropdown/' + company_id + '?development_id=' + development.val(), 'Development', 'coinsDropdown')
          }
  
        }
        ).addClass('js-ignore').trigger('change')

      },

      changeProductCategory: function (category)
      {

        var row = category.closest('.row-item')

        var product = $('.js-product', row)

        APPLICATION._APPLICATION.loadDropdown(product, APPLICATION._PATH_PREFIX + 'product/dropdown/' + category.val() + '?product_id=' + product.val(), 'Product', 'dropdown')

      }

    }

  }